// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = require('./$.to-iobject');

require('./$.object-sap')('getOwnPropertyDescriptor', function($getOwnPropertyDescriptor){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/es6.object.get-own-property-descriptor.js
// module id = 130
// module chunks = 0